export enum HeadlessChromeRenderingStatus {
	LOADING = 'DASHBOARD_LOADING',
	READY = 'DASHBOARD_READY'
}

